/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/

import { LinearProgress } from "@mui/material";
import Topheader from "../../../Layout/header/header";
import "./documentation.css";

const Documentation = () => {
  //Adding comment for a test commit
  return (
    <div className="appListContainerDoc">
      <Topheader />
      <LinearProgress />

      <iframe
        title="documentation"
        className="doc"
        src="https://developer-docs.eks-store-qa.store.ignite.aws.harmandev.com/developer_docs/developer-consol/"
        style={{ border: "none" }}
      ></iframe>
    </div>
  );
};

export default Documentation;
